import React from "react";
import {
    BrowserRouter as Router,
    Route,
    Routes,
    useLocation,
    Navigate,
    Outlet,
    // useLocation,
    // Navigate,
    // Outlet
} from "react-router-dom";

import { IndexPage } from "./Components/IndexPage/IndexPage";
import { HerosectionsAll } from "./Components/HeroSectionAll/HerosectionsAll";
import { Services } from "./Components/OurServices/LearningAndDevelopment/Principles/Services";
import { ContractOfInsurance } from "./Components/OurServices/LearningAndDevelopment/Principles/ContractOfInsurance";
import { Contact } from "./Components/Contact/Contact";
import { LearningAndDevelopment } from "./Components/OurServices/LearningAndDevelopment/LearningAndDevelopment";
import { Consultancy } from "./Components/OurServices/Consultancy/Consultancy";
import { AllOurTeam } from "./Components/AllOurTeam/AllOurTeam";
import { Vision } from "./Components/About/Vision/Vision";
import { Mission } from "./Components/About/Mission/Mission";
import { About } from "./Components/About/About";
import { Values } from "./Components/About/Values/Values";
import { Commitment } from "./Components/About/Commitment/Commitment";
import { HullInsurance } from "./Components/OurServices/LearningAndDevelopment/HullInsurance/HullInsurance";
import { ReturnOfPremium } from "./Components/OurServices/LearningAndDevelopment/Principles/ReturnOfPremium";
import { Subrogation } from "./Components/OurServices/LearningAndDevelopment/Principles/Subrogation";
import { Contribution } from "./Components/OurServices/LearningAndDevelopment/Principles/Contribution";
import { InsurableInterest } from "./Components/OurServices/LearningAndDevelopment/Principles/InsurableInterest";
import { Indemnity } from "./Components/OurServices/LearningAndDevelopment/Principles/Indemnity";
import { MarineLiabilityInsurance } from "./Components/OurServices/LearningAndDevelopment/MarineLiabilityInsurance/MarineLiabilityInsurance";
import { CargoInsurance } from "./Components/OurServices/LearningAndDevelopment/CargoInsurance/CargoInsurance";
import { PrinciplesDiagram } from "./Components/OurServices/LearningAndDevelopment/Principles/PrinciplesDiagram";
import { Overview } from "./Components/Overview/Overview";
import { UtmostGoodFaith } from "./Components/OurServices/LearningAndDevelopment/Principles/UtmostGoodFaith";
import { TrainingOnlineOffline } from "./Components/OurServices/LearningAndDevelopment/TrainingOnlineOffline/TrainingOnlineOffline";
import { WorkshopOnlineOffline } from "./Components/OurServices/LearningAndDevelopment/WorkshopOnlineOffline/WorkshopOnlineOffline";
import { Seminars } from "./Components/OurServices/LearningAndDevelopment/Seminars/Seminars";
import { Lectures } from "./Components/OurServices/LearningAndDevelopment/Lectures/Lectures";
import { IndividualCorporateTrainings } from "./Components/OurServices/LearningAndDevelopment/IndividualCorporateTrainings/IndividualCorporateTrainings";
import { HullClaim } from "./Components/OurServices/Consultancy/HullClaim/HullClaim";
import { CargoClaim } from "./Components/OurServices/Consultancy/CargoClaim/CargoClaim";
import { LossofHireClaims } from "./Components/OurServices/Consultancy/LossofHireClaims/LossofHireClaims";
import { ShipRepairsLiabilityClaims } from "./Components/OurServices/Consultancy/ShipRepairsLiabilityClaims/ShipRepairsLiabilityClaims";
import { BuilderRisksClaims } from "./Components/OurServices/Consultancy/BuilderRisksClaims/BuilderRisksClaims";
import { OurTeam } from "./Components/OurTeam/OurTeam";
import { MaritimeOperationalRiskManagement } from "./Components/OurServices/Consultancy/OperationalRiskManagement/MaritimeOperationalRiskManagement";
import { DISPUTEPREVENTIONANDRESOLUTIONADVISORYSERVICES } from "./Components/OurServices/Consultancy/OperationalRiskManagement/DISPUTEPREVENTIONANDRESOLUTIONADVISORYSERVICES";
import { CasualtyRespone } from "./Components/OurServices/Consultancy/OperationalRiskManagement/CasualtyRespone";
import { Valuation } from "./Components/OurServices/Consultancy/Valuation/Valuation";
import { FORENSICAUDIT } from "./Components/OurServices/Consultancy/FORENSICAUDIT/FORENSICAUDIT";
import { GeneralAverageClaims } from "./Components/OurServices/Consultancy/GeneralAverageClaims/GeneralAverageClaims";
import { GeneralAverageClaimsReadmore } from "./Components/OurServices/Consultancy/GeneralAverageClaims/GeneralAverageClaimsReadmore";
import { DoGA } from "./Components/OurServices/Consultancy/GeneralAverageClaims/DoGA";
import { CollisionLiability } from "./Components/OurServices/Consultancy/CollisionLiability/CollisionLiability";
import { ExaminationStructure } from "./Components/IndexPage/ExaminationPreparation/ExaminationStructure";
import { Webinars } from "./Components/IndexPage/Webinars/Webinars";
import MainDashboard from "./Components/AdminPages/MainDashboard";
import { LogIn } from "./Components/Public/Login";
import { LicentiateCertificate } from "./Components/AdminPages/LicentiateCertificate";
import { OptionalSubjectList } from "./Components/AdminPages/OptionalSubjectList";
import { useAuthState } from "./helper/Context/context";
// import { LicentiateCertificate } from "./Components/AdminPages/LicentiateCertificate";
// import { OptionalSubjectList } from "./Components/AdminPages/OptionalSubjectList";

export default function AllRoutes() {

    const RequiredAuth = () => {
        const userDetails = useAuthState();
        const { UserID } = userDetails.user
        // console.log('userDetails', userDetails)
        let Auth = sessionStorage.getItem('A454A')
        // console.log('A454A',sessionStorage.getItem('A454A'))

        // if (RoleID == 0) {
        //     document.body.classList.remove('sidebar-icon-only');
        // } else {
        //     document.body.classList.add('sidebar-icon-only');
        // }

        const location = useLocation()
        if (!Auth) {
            return <Navigate to="/" state={{ from: location }} />
        }

        return <Outlet />
    }

    return (
        <>
            <div className="">
                <Router>
                    <Routes>
                        {/* <Route
                        exact path="/"
                        element={<LogIn />}
                    /> */}

                        <Route
                            exact path="/"
                            element={<IndexPage />}
                        />

                        <Route
                            exact path="/About"
                            element={<About />}
                        />
                        <Route
                            exact path="/Vision"
                            element={<Vision />}
                        />
                        <Route
                            exact path="/Mission"
                            element={<Mission />}
                        />
                        <Route
                            exact path="/Values"
                            element={<Values />}
                        />
                        <Route
                            exact path="/Commitment"
                            element={<Commitment />}
                        />
                        <Route
                            exact path="/AllOurTeam"
                            element={<AllOurTeam />}
                        />

                        <Route
                            exact path="/Services"
                            element={<Services />}
                        />

                        <Route
                            exact path="/LearningAndDevelopment"
                            element={<LearningAndDevelopment />}
                        />
                        <Route
                            exact path="/Consultancy"
                            element={<Consultancy />}
                        />

                        <Route
                            exact path="/HerosectionsAll"
                            element={<HerosectionsAll />}
                        />
                        <Route
                            exact path="/ContractOfInsurance"
                            element={<ContractOfInsurance />}
                        />
                        <Route
                            exact path="/UtmostGoodFaith"
                            element={<UtmostGoodFaith />}
                        />
                        <Route
                            exact path="/Indemnity"
                            element={<Indemnity />}
                        />
                        <Route
                            exact path="/InsurableInterest"
                            element={<InsurableInterest />}
                        />
                        <Route
                            exact path="/Contribution"
                            element={<Contribution />}
                        />
                        <Route
                            exact path="/Subrogation"
                            element={<Subrogation />}
                        />
                        <Route
                            exact path="/ReturnOfPremium"
                            element={<ReturnOfPremium />}
                        />

                        <Route
                            exact path="/Contact"
                            element={<Contact />}
                        />

                        <Route
                            exact path="/CargoInsurance"
                            element={<CargoInsurance />}
                        />

                        <Route
                            exact path="/HullInsurance"
                            element={<HullInsurance />}
                        />

                        <Route
                            exact path="/MarineLiabilityInsurance"
                            element={<MarineLiabilityInsurance />}
                        />

                        <Route
                            exact path="/PrinciplesDiagram"
                            element={<PrinciplesDiagram />}
                        />
                        <Route
                            exact path="/Overview"
                            element={<Overview />}
                        />
                        <Route
                            exact path="/TrainingOnlineOffline"
                            element={<TrainingOnlineOffline />}
                        />
                        <Route
                            exact path="/WorkshopOnlineOffline"
                            element={<WorkshopOnlineOffline />}
                        />
                        <Route
                            exact path="/Seminars"
                            element={<Seminars />}
                        />
                        <Route
                            exact path="/Lectures"
                            element={<Lectures />}
                        />
                        <Route
                            exact path="/IndividualCorporateTrainings"
                            element={<IndividualCorporateTrainings />}
                        />
                        <Route
                            exact path="/HullClaim"
                            element={<HullClaim />}
                        />
                        <Route
                            exact path="/GeneralAverageClaims"
                            element={<GeneralAverageClaims />}
                        />
                        <Route
                            exact path="/GeneralAverageClaimsReadmore"
                            element={<GeneralAverageClaimsReadmore />}
                        />
                        <Route
                            exact path="/CargoClaim"
                            element={<CargoClaim />}
                        />
                        <Route
                            exact path="/LossofHireClaims"
                            element={<LossofHireClaims />}
                        />
                        <Route
                            exact path="/ShipRepairsLiabilityClaims"
                            element={<ShipRepairsLiabilityClaims />}
                        />
                        <Route
                            exact path="/BuilderRisksClaims"
                            element={<BuilderRisksClaims />}
                        />

                        <Route
                            exact path="/MaritimeOperationalRiskManagement"
                            element={<MaritimeOperationalRiskManagement />}
                        />
                        <Route
                            exact path="/DISPUTEPREVENTIONANDRESOLUTIONADVISORYSERVICES"
                            element={<DISPUTEPREVENTIONANDRESOLUTIONADVISORYSERVICES />}
                        />
                        <Route
                            exact path="/CasualtyRespone"
                            element={<CasualtyRespone />}
                        />

                        <Route
                            exact path="/OurTeam"
                            element={<OurTeam />}
                        />
                        <Route
                            exact path="/Valuation"
                            element={<Valuation />}
                        />
                        <Route
                            exact path="/FORENSICAUDIT"
                            element={<FORENSICAUDIT />}
                        />

                        <Route
                            exact path="/DoGA"
                            element={<DoGA />}
                        />

                        <Route
                            exact path="/CollisionLiability"
                            element={<CollisionLiability />}
                        />
                        <Route
                            exact path="/ExaminationStructure"
                            element={<ExaminationStructure />}
                        />

                        <Route
                            exact path="/Webinars"
                            element={<Webinars />}
                        />


                        {/* ########### Admin Routes ############ */}

                        <Route
                            exact path="/adminlogin"
                            element={<LogIn />}
                        />

                        <Route exact element={<RequiredAuth />}>

                            <Route
                                exact path="/MainDashboard"
                                element={<MainDashboard />}
                            />

                            <Route
                                exact path="/LicentiateCertificate"
                                element={<LicentiateCertificate />}
                            />

                            <Route
                                exact path="/OptionalSubjectList"
                                element={<OptionalSubjectList />}
                            />
                        </Route>

                        {/* ########### Admin Routes ############ */}

                    </Routes>



                </Router>
            </div>
        </>
    )
}